import { configureStore } from '@reduxjs/toolkit'
import authReducer from "./reducers/auth";
import initiativeReducer from "./reducers/initiative";
import configReducer from "./reducers/config";

export default configureStore({
  reducer: {
    auth          : authReducer
    ,initiative   : initiativeReducer
    ,config       : configReducer
  }
})